import { defineStore } from 'pinia';
import { ref } from 'vue';
import axiosInstance from '@/shared/utils/axios';

export const useResellerStore = defineStore('reseller', () => {
  const resellers = ref<Array<{ _id: string; name: string }>>([]);
  const resellersData = ref<{
    resellers: Array<any>;
    totalCount: number;
    page: number;
    limit: number;
    totalPages: number;
  }>({
    resellers: [],
    totalCount: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  });
  const resellersLoading = ref(false);

  const fetchResellers = async (params: { page?: number; limit?: number; search?: string; branch_id?: string } | string = "", branchId: string = "") => {
    resellersLoading.value = true;
    try {
      let queryParams: any = {};
      if (typeof params === 'object') {
        queryParams = { ...params };
      } else {
        if (params) queryParams.search = params;
        if (branchId) queryParams.branch_id = branchId;
      }
      const response = await axiosInstance.get('/api/resellers', { params: queryParams });
      const rows = response.data?.resellers || [];
      resellers.value = rows.map((r: any) => ({ _id: r._id, name: r.name }));
      resellersData.value = {
        resellers: rows,
        totalCount: response.data?.pagination?.totalCount || rows.length,
        page: response.data?.pagination?.page || 1,
        limit: response.data?.pagination?.limit || 10,
        totalPages: response.data?.pagination?.totalPages || 1,
      };
      return response.data;
    } catch (error) {
      console.error('Error fetching resellers:', error);
      throw error;
    } finally {
      resellersLoading.value = false;
    }
  };

  const addReseller = async (resellerData: any) => {
    try {
      const response = await axiosInstance.post('/api/resellers', resellerData);
      await fetchResellers();
      return response.data;
    } catch (error) {
      console.error('Error adding reseller:', error);
      throw error;
    }
  };

  const updateReseller = async (id: string, resellerData: any) => {
    try {
      const response = await axiosInstance.put(`/api/resellers/${id}`, resellerData);
      await fetchResellers();
      return response.data;
    } catch (error) {
      console.error('Error updating reseller:', error);
      throw error;
    }
  };

  const deleteReseller = async (id: string) => {
    try {
      const response = await axiosInstance.delete(`/api/resellers/${id}`);
      await fetchResellers();
      return response.data;
    } catch (error) {
      console.error('Error deleting reseller:', error);
      throw error;
    }
  };

  return {
    resellers,
    resellersData,
    resellersLoading,
    fetchResellers,
    addReseller,
    updateReseller,
    deleteReseller
  };
});
